import type { PromotionStatus } from '@kynetik/shared';

import { apiClient } from './client';
import type { Promotion, PromotionCode } from './types';

interface PaginationInfo {
  total: number;
  count: number;
  perPage: number;
  currentPage: number;
  totalPages: number;
}

export const promotionsApi = {
  async list(
    params: {
      status?: PromotionStatus;
      channelId?: string;
      redemptionType?: 'AUTOMATIC' | 'COUPON';
      includeExpired?: boolean;
      page?: number;
      limit?: number;
    } = {}
  ): Promise<{
    promotions: Promotion[];
    pagination: PaginationInfo;
    bcAdminUrl: string;
  }> {
    const searchParams = new URLSearchParams();
    if (params.status) searchParams.set('status', params.status);
    if (params.channelId) searchParams.set('channelId', params.channelId);
    if (params.redemptionType) searchParams.set('redemptionType', params.redemptionType);
    if (params.includeExpired) searchParams.set('includeExpired', 'true');
    if (params.page) searchParams.set('page', String(params.page));
    if (params.limit) searchParams.set('limit', String(params.limit));

    const query = searchParams.toString();
    return apiClient.request(`/promotions${query ? `?${query}` : ''}`);
  },

  async get(promotionId: number): Promise<{
    promotion: Promotion & { codes: PromotionCode[] };
  }> {
    return apiClient.request(`/promotions/${promotionId}`);
  },
};
